// extracted by mini-css-extract-plugin
export var chip = "_e9-0";
export var filterDropdown = "_e9-5";
export var filterItem = "_e9-6";
export var icon = "_e9-1";
export var removeButton = "_e9-3";
export var removeIcon = "_e9-4";
export var separator = "_e9-2";